import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col, Button } from 'react-bootstrap';
import { IQuoteActions } from '../../../../services/quote/models';
import { actions as quoteActions } from '../../../../services/quote/reducer';

interface IHomePageProps {
  actions: {
    quote: IQuoteActions;
  };
}

class HomePage extends React.Component<IHomePageProps> {

  public render() {
    return (
      <div className="front-page animated fadeIn">
        <div className="container" />
      </div>
    );
  }
}

export default connect(
  null,
  (dispatch) => ({
    actions: {
      quote: bindActionCreators({ ...quoteActions }, dispatch),
    },
  }),
)(HomePage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/HomePage/index.tsx